module.exports = __webpack_public_path__ + "img/logo.1183c6a4.png";